import { Injectable } from '@angular/core';

import { BaseEditCreateService, HttpService, NotificationService } from '../../../tms-shared';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseEditCreateService<T, TEdit> extends BaseEditCreateService<T, TEdit> {
  protected constructor(
    protected baseRoute: string,
    public name: string,
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(baseRoute, name, httpService, notificationService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
